import { render, staticRenderFns } from "./CardFinal.vue?vue&type=template&id=bd5553de&scoped=true&"
import script from "./CardFinal.vue?vue&type=script&lang=js&"
export * from "./CardFinal.vue?vue&type=script&lang=js&"
import style0 from "./CardFinal.vue?vue&type=style&index=0&id=bd5553de&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5553de",
  null
  
)

export default component.exports